<template>
  <div>
    <view-component title="Pendukung Administrasi" :schema="schema" class="my-2" @edit="onEdit" />
    <base-modal-full ref="modal" generalError title="Update Data Pendukung Administrasi" @save="onSave">
      <formulir-administrasi ref="formulir" :initValue="formulir.init" :masters="masters" :detail="formulir.detail" />
    </base-modal-full>
  </div>
</template>

<script>
import ViewComponent from '../base/View';
import FormulirAdministrasi from '../forms/Administrasi';
import { mapActions } from 'vuex';

export default {
  name: 'Administrasi',
  components: { ViewComponent, FormulirAdministrasi },
  props: {
    index: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBiodataUpdates: {
      type: Array,
      default: () => [],
    },
    kVervalPsp: {
      type: Number,
      default: 1,
    },
    isEditBiodata: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    ptk() {
      return this.$getDeepObj(this.biodata, 'ptk') || {};
    },

    schema() {
      return [
        {
          items: [
            {
              label: 'Status Kepegawaian',
              value: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pegawai.keterangan') || '',
              update: this.keyBiodataUpdates.includes('k_pegawai_psp'),
            },
            {
              label: 'NIP',
              value: this.biodata.nip || '',
              update: this.keyBiodataUpdates.includes('nip'),
              hidden: !this.biodata.nip,
            },
            {
              label: 'Pangkat / Golongan',
              value: this.$getDeepObj(this.biodata, 'm_golongan.keterangan') || '',
              update: this.keyBiodataUpdates.includes('k_golongan'),
              hidden: !this.biodata.k_golongan,
            },
            { label: 'NPWP', value: this.biodata.npwp || '', update: this.keyBiodataUpdates.includes('npwp') },
            {
              label: 'Nama Bank dan Cabang Bank',
              value:
                this.biodata.rekening_bank && this.biodata.rekening_cabang
                  ? `${this.biodata.rekening_bank} - ${this.biodata.rekening_cabang}`
                  : '',
              update:
                this.keyBiodataUpdates.includes('rekening_bank') || this.keyBiodataUpdates.includes('cabang_bank'),
            },
            {
              label: 'Nomor rekening',
              value: this.biodata.rekening_nomor || '',
              update: this.keyBiodataUpdates.includes('rekening_nomor'),
            },
            {
              label: 'Nama di Akun Bank',
              value: this.biodata.rekening_nama || '',
              update: this.keyBiodataUpdates.includes('rekening_nama'),
            },
          ],
        },
      ];
    },
  },
  methods: {
    ...mapActions('biodata', ['actions']),

    onEdit() {
      if (!this.isEditBiodata) {
        this.$error('Data tidak bisa diubah karena telah diajukan');
        return;
      }

      if (this.index.tutup) {
        this.$error(this.index.tutup);
        return;
      }

      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.biodata);
      });
    },

    onSave() {
      const params = this.$refs.formulir.getValue();

      this.actions({ params, update: this.$isObject(this.edit), action: 'save-administrasi' })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
